import { clsx } from "clsx";

export default function TextSubHeader({
  children,
  className,
}: React.PropsWithChildren<{
  children: React.ReactNode;
  className?: string;
}>) {
  return (
    <div
      className={clsx(
        "mb-4 text-[20px]/[26px] font-medium lg:text-[24px]/[32px]",
        className,
      )}
    >
      {children}
    </div>
  );
}
